import { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Layout/Layout";
import {
  ContactUs,
  Error,
  Login,
  SignUP,
  VirtualCards,
  ForgetPassword,
  MyProfile,
  TOS,
  PrivacyPolicy,
  AboutUs,
  NewPassword,
} from "./pages";
import { LoginContext } from "./Contexts/loginContext";
import ProtectedRoute from "./Contexts/ProtectedRoute";
import { VerifyKyc } from "./components";
import { BackButtonProvider } from "./Contexts/BackButtonContext";
import { Hero } from "./sections";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to detect if the app is running on a mobile device
    const checkIsMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|iphone|ipad|ipod/i.test(userAgent);
      const isSmallScreen = window.innerWidth < 768; // You can adjust this breakpoint if needed

      setIsMobile(isMobileDevice && isSmallScreen);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  useEffect(() => {
    const changeTopBarColor = (color) => {
      document.querySelector('meta[name="theme-color"]').setAttribute("content", color);
    };

    changeTopBarColor("#11272a");
  }, []);

  // Redirect to /virtual-cards if logged in and root path is accessed
  useEffect(() => {
    if (token && window.location.pathname === "/") {
      window.location.href = "/virtual-cards";
    }
  }, [token]);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <Error />,
      children: [
        {
          index: true,
          element: (
            <BackButtonProvider>
              <VirtualCards />
            </BackButtonProvider>
          ),
        },
        { path: "aboutus", element: <ContactUs /> },
        { path: "privacy-policy", element: <Hero /> },
        { path: "NewPassword", element: <NewPassword /> },
        {
          path: "transaction",
          element: (
            <BackButtonProvider>
              <AboutUs />
            </BackButtonProvider>
          ),
        },
        {
          path: "virtual-cards",
          element: (
            <BackButtonProvider>
              <VirtualCards />
            </BackButtonProvider>
          ),
        },
        {
          path: "virtual-cards/verify",
          element: <ProtectedRoute element={<VerifyKyc />} />,
        },
        {
          path: "verify",
          element: <ProtectedRoute element={<VerifyKyc />} />,
        },
        {
          path: "/my-profile",
          element: <ProtectedRoute element={<MyProfile />} />,
        },
      ],
    },
    {
      path: "/passwordchange",
      element: <PrivacyPolicy />,
    },
    {
      path: "/tos",
      element: <ProtectedRoute element={<TOS />} />,
    },
    { path: "/login", element: <Login /> },
    { path: "/sign-up", element: <SignUP /> },
    { path: "/forget-password", element: <ForgetPassword /> },
  ]);

  const [user, setUser] = useState({});

  return (
    <LoginContext.Provider value={{ user, setUser, token, setToken }}>
      {isMobile ? (
        <RouterProvider router={router} />
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <h1>Mobile Only</h1>
          <p>This application is only accessible on mobile devices.</p>
        </div>
      )}
    </LoginContext.Provider>
  );
};

export default App;
